import React from 'react'
import { Link } from 'react-router-dom';
import SplashScreen from '../common/Splash/screen';
import credentials from './credentials.json';

const Credentials = () => {
    

    const academicList = credentials.Academic.map((item) => {
        return (
            <span className='academic_item center flex_column'>
                <div className='name'>
                    {item.name}
                </div>
                <div className='inst'>
                    {item.institution}
                </div>
                <div className='desc'>
                    {item.description}
                </div>
            </span>
        )
    })

    const csList = credentials['Computer Science'].map((item) => {
        const skills = item.skills.map((skill) => {
            return <span className='soft_skills'>• {skill}</span>
        })
        return (
            <span className='cs_item cred center flex_column'>
                <div className='name'>
                    {item.name}
                </div>
                <div className='title'>
                    {item.title}
                </div>
                <div className='inst'>
                    {item.institution}
                </div>
                <div className='desc'>
                    {item.description}
                </div>
                <Link className='link' to={item.link}>View Course</Link>
                <div className='skills'>
                    {[skills]}
                </div>
            </span>
        )
    })

    const dsList = credentials['Data Science'].map((item) => {
        if (item.name == "badges") {
            return <Link className='badge' to={item.link}>
                <img src={item.photo} />
            </Link>
        }
        const skills = item.skills.map((skill) => {
            return <span className='soft_skills'>• {skill}</span>
        })
        return (
            <span className='ds_item cred center flex_column'>
                <div className='name'>
                    {item.name}
                </div>
                <div className='title'>
                    {item.title}
                </div>
                <div className='inst'>
                    {item.institution}
                </div>
                <div className='desc'>
                    {item.description}
                </div>
                <Link className='link' to={item.link}>View Course</Link>
                <div className='skills'>
                    {[skills]}
                </div>
            </span>
        )
    })

    return (
        <div id='credentials'>
            <SplashScreen name="Credentials" bgColor="white" color="#7D0065" photo="/assets/credentials/all2.png" />
            <div className='center'>
                <div className='exp_left'>
                    <div className='exp_filter'>

                    </div>
                </div>
                <div className='cred_right'>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Computer Science
                                <div className='poster_hr'/>
                            </div>
                        </div>
                        <div id='Computer Science' className='project_list center' style={{flexWrap: "wrap"}}>
                            {[csList]}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start",  backgroundColor: "#6A0053", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Data Science
                                <div className='poster_hr'/>
                            </div>
                        </div>
                        <div id='Data Science' className='project_list center' style={{flexWrap: "wrap"}}>
                            {[dsList]}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", backgroundColor: "#4F003D", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Academic
                                <div className='poster_hr'/>
                            </div>
                        </div>
                        <div id='Academic' className='project_list center' style={{flexWrap: "wrap"}}>
                            {[academicList]}
                        </div>
                    </div>
                    {/*<div id='Extra-Curricular' className='subtype'>
                        Extra-Curricular
                    </div>
                    <div className='subtype_section center'>
                    </div>*/}
                </div>
            </div>
        </div>
    )
}

export default Credentials;